"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var antd_1 = require("antd");
var react_promise_tracker_1 = require("react-promise-tracker");
var store_1 = require("../../store");
var BreadcrumbBar_1 = __importDefault(require("../BreadcrumbBar"));
var Menu_1 = __importDefault(require("../Menu"));
var Icon_1 = __importDefault(require("../Icon"));
var FormatText_1 = __importDefault(require("../FormatText"));
var Loading_1 = __importDefault(require("../Loading"));
var Header = antd_1.Layout.Header, Sider = antd_1.Layout.Sider;
var MenuTrigger = function (_a) {
    var appVersion = _a.appVersion, collapsed = _a.collapsed;
    return (react_1.default.createElement("div", { className: "ant-app-menu-trigger" },
        appVersion && !collapsed && react_1.default.createElement(FormatText_1.default, { id: "ui.commons.version", params: { version: appVersion } }),
        collapsed ? react_1.default.createElement(Icon_1.default, { name: "arrows-right_4" }) : react_1.default.createElement(Icon_1.default, { name: "arrows-back" })));
};
var Workspace = function (props) {
    var menu = props.menu, children = props.children;
    var setHasMenu = store_1.useActions(function (actions) { return actions.ui.setHasMenu; });
    react_1.useEffect(function () {
        setHasMenu(!!menu);
    }, [menu, setHasMenu]);
    var appConfig = store_1.useStore(function (state) { return state.ui.appConfig; });
    var menuFullCollapsed = store_1.useStore(function (state) { return state.ui.menuFullCollapsed; });
    var menuIconCollapsed = store_1.useStore(function (state) { return state.ui.menuIconCollapsed; });
    var toggleMenuFullCollapse = store_1.useActions(function (state) { return state.ui.toggleMenuFullCollapse; });
    var toggleMenuIconCollapse = store_1.useActions(function (state) { return state.ui.toggleMenuIconCollapse; });
    var menuCollapsed = menuFullCollapsed || menuIconCollapsed;
    var toggleMenuCollapse = menuFullCollapsed ? toggleMenuFullCollapse : toggleMenuIconCollapse;
    var promiseInProgress = react_promise_tracker_1.usePromiseTracker().promiseInProgress;
    return (react_1.default.createElement(Loading_1.default, { loading: promiseInProgress },
        react_1.default.createElement(antd_1.Layout, null,
            react_1.default.createElement(Sider, { theme: "dark", collapsible: true, width: 288, collapsedWidth: menuFullCollapsed ? 0 : 48, trigger: react_1.default.createElement(MenuTrigger, { appVersion: appConfig.version, collapsed: menuCollapsed }), collapsed: menuCollapsed, onCollapse: toggleMenuCollapse },
                react_1.default.createElement(Menu_1.default, __assign({}, menu))),
            react_1.default.createElement(antd_1.Layout, null,
                react_1.default.createElement(Header, { className: "ant-app-breadcrumb-bar" },
                    react_1.default.createElement(BreadcrumbBar_1.default, __assign({}, menu))),
                children))));
};
exports.default = Workspace;
